/**
 * Class for handling batches.
 *
 * @see {@link https://www.meilisearch.com/docs/reference/api/batches}
 */
export class BatchClient {
    #httpRequest;
    constructor(httpRequests) {
        this.#httpRequest = httpRequests;
    }
    /** {@link https://www.meilisearch.com/docs/reference/api/batches#get-one-batch} */
    async getBatch(uid) {
        const batch = await this.#httpRequest.get({
            path: `batches/${uid}`,
        });
        return batch;
    }
    /** {@link https://www.meilisearch.com/docs/reference/api/batches#get-batches} */
    async getBatches(batchesQuery) {
        const batches = await this.#httpRequest.get({
            path: "batches",
            params: batchesQuery,
        });
        return batches;
    }
}
//# sourceMappingURL=batch.js.map